import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export function ServiceBox(props) {
    return (
        <div className="col-lg-4 col-sm-6 services-all-box">
            <div className="services-box text-center">
                <div className="services-icon">
                    <span>
                        <FontAwesomeIcon icon={props.Icon} />
                    </span>
                </div>
                <div className="services-box-title">
                    <h4>{props.Title}</h4>
                    <p>{props.Content}</p>
                </div>
            </div>
        </div>
    )
}